import { createI18n } from 'vue-i18n'
import lt from '../locales/lt.json'

export const DEFAULT_LOCALE = 'lt'

export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    lt,
  },
})
